import _asyncToGenerator from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import Screens from '..';
import GameProviders, { providersList } from '../../api/GameInterface/providers';
import NavigationConstants from '../../components/LobbyOverlay/NavigationConstants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Logger from '../../lib/analytics/logger';
import audio from '../../utils/audio';
import Utils from '../../utils';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
import ERROR_CODE from '../../utils/errorCodes/index.js';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
import { EVENT_EMITTER_TYPE, FTUE_STEPS_KEYS, PLATFORM, GAME_TRIGGERS } from '../../constants';
import { skipTutorialGame as _skipTutorialGame } from '../../components/OnboardingLayer/utils/skipTutorialGame';
import { ACTION_COMMANDS_TYPE } from '../../api/ActionCommandsInterface/constants';
import Emitter from '../../services/EmitterService';
import Platform from '../../utils';
var Game = /*#__PURE__*/function (_Component) {
  function Game(props) {
    var _this;
    _classCallCheck(this, Game);
    _this = _callSuper(this, Game, [props]);
    _this.handleScreenFocus = function () {
      // On every focus (including re-entries without remount), clear leftover
      // FTUE state. If the game already finished initializing, re-check the
      // action command so a new DISPLAY_GAME_TUTORIAL gets armed.
      _this.props.clearOnboarding();
      if (_this.state.provider) _this.checkOnboardingGameTutorialAction();
    };
    _this._backButtonHandler = function () {
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Home);
    };
    _this._sessionInvalidatedHandler = function () {
      audio.pauseMusic();
      audio.pauseSfx('crowdsTalking');
      QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined), RouteParamConstants.PARAM_GAME_ID, undefined), RouteParamConstants.PARAM_GAME_TRIGGER, undefined), RouteParamConstants.PARAM_CHEAT_MENU, undefined), RouteParamConstants.PARAM_CHEAT_MENU_ACTIVE, undefined), RouteParamConstants.PARAM_SNEAK_PEEK_END_DATE, undefined));
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Home);
    };
    _this.checkOnboardingGameTutorialAction = function () {
      var _this$props = _this.props,
        actionCommands = _this$props.actionCommands,
        setOnboardingFtueStep = _this$props.setOnboardingFtueStep,
        ftueStep = _this$props.ftueStep,
        setFtueState = _this$props.setFtueState,
        setFtueGameId = _this$props.setFtueGameId;
      if ((actionCommands === null || actionCommands === void 0 ? void 0 : actionCommands.actionType) === ACTION_COMMANDS_TYPE.DISPLAY_GAME_TUTORIAL && ftueStep !== FTUE_STEPS_KEYS.SHOW_IN_GAME) {
        var _actionCommands$gameT;
        setFtueState(true);
        setFtueGameId((_actionCommands$gameT = actionCommands.gameTutorial) === null || _actionCommands$gameT === void 0 || (_actionCommands$gameT = _actionCommands$gameT.gameId) === null || _actionCommands$gameT === void 0 ? void 0 : _actionCommands$gameT.toString());
        setOnboardingFtueStep(FTUE_STEPS_KEYS.SHOW_IN_GAME);
        // Consume the action command now that the game has taken control of the
        // FTUE. Otherwise it stays in the store and re-influences the lobby (e.g.
        // GamePage's `hasGameTutorial` selector) plus risks re-arming the FTUE
        // on subsequent renders. Skip already does this; treating the normal
        // consumption the same way keeps a single source of truth.
        if (actionCommands.uuid) {
          Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
            actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND,
            data: {
              uuid: actionCommands.uuid
            }
          });
        }
      }
    };
    _this.showAdBlockerPopup = function () {
      var _this$props2 = _this.props,
        lastTimeAdBlockerSeen = _this$props2.lastTimeAdBlockerSeen,
        setLastTimeAdBlockerSeen = _this$props2.setLastTimeAdBlockerSeen;
      var newTime = new Date();
      var timeLimit = 86400000; // 24 * 60 * 60 * 1000 = 24 hours in ms;
      var timeDiff = !lastTimeAdBlockerSeen ? 0 : newTime - new Date(lastTimeAdBlockerSeen);
      if (timeDiff > timeLimit || timeDiff === 0) {
        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.AdBlocker));
        setLastTimeAdBlockerSeen(newTime);
      }
    };
    _this.fetchInitGame = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(gameId, trigger) {
        var _this$props3, isEmbedded, gameDownloadFailed, getInitGame, iosPlatform;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _this$props3 = _this.props, isEmbedded = _this$props3.isEmbedded, gameDownloadFailed = _this$props3.gameDownloadFailed, getInitGame = _this$props3.getInitGame;
              iosPlatform = Platform.getPlatform() === PLATFORM.IOS;
              _context.next = 5;
              return getInitGame({
                gameId: gameId,
                isEmbedded: isEmbedded,
                gameDownloadFailed: gameDownloadFailed,
                iosPlatform: iosPlatform,
                trigger: trigger || GAME_TRIGGERS.URL
              }, {
                forceRefetch: true
              });
            case 5:
              return _context.abrupt("return", _context.sent);
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
                code: ERROR_CODE.INIT_GAME_FAIL
              });
              return _context.abrupt("return", false);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.setGameState = function (game, gameInterface) {
      if (game.PROVIDER !== providersList.NETENT) {
        _this.setState(_objectSpread({
          provider: game.PROVIDER,
          gameLink: game.URL,
          netEntConfig: null,
          embedData: game.EMBED_DATA
        }, gameInterface && {
          gameInterface: gameInterface
        }));
      } else {
        _this.setState(_objectSpread(_objectSpread({
          provider: game.PROVIDER,
          gameLink: game.URL.game_server_url
        }, gameInterface && {
          gameInterface: gameInterface
        }), {}, {
          netEntConfig: {
            gameId: game.PROVIDER_GAME_ID,
            languagePrefix: 'SC',
            staticServerURL: game.URL.static_server_url,
            gameServerURL: game.URL.game_server_url,
            sessionId: game.SESSION_ID
          }
        }));
      }
    };
    _this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$props4, setNavState, setGameId, navigation, setLastGameVisited, token, onGameUnavailable, setGameType, gid, trigger, game, gameInterface;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this$props4 = _this.props, setNavState = _this$props4.setNavState, setGameId = _this$props4.setGameId, navigation = _this$props4.navigation, setLastGameVisited = _this$props4.setLastGameVisited, token = _this$props4.token, onGameUnavailable = _this$props4.onGameUnavailable, setGameType = _this$props4.setGameType;
            setNavState(NavigationConstants.HIDE_BOTTOM);
            gid = navigation.getParam('gid', '0');
            trigger = navigation.getParam('tr', GAME_TRIGGERS.URL);
            setGameId(gid);
            setLastGameVisited(gid);
            _this.trackOpenedGamesAmount(gid);
            if (!(gid && token.token)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 10;
            return _this.fetchInitGame(gid, trigger);
          case 10:
            game = _context2.sent;
            if (game.PROVIDER) {
              _context2.next = 14;
              break;
            }
            onGameUnavailable();
            return _context2.abrupt("return");
          case 14:
            setGameType(game.GAME_TYPE);
            gameInterface = new GameProviders[game.PROVIDER]({
              RFValue: _this.props.RFValue,
              deviceInfo: _this.props.deviceInfo,
              dimension: _this.props.dimension,
              gameType: game.GAME_TYPE,
              BetInfo: _this.parseBetInfo(_objectSpread({}, game.BET_INFO)),
              ExitFunc: _this._backButtonHandler,
              SessionInvalidated: _this._sessionInvalidatedHandler,
              GameReady: function GameReady() {
                console.log('Game provider has told us that it is ready');
              },
              OutOfCoins: function OutOfCoins() {
                console.log('Game provider has told us that the user is out of coins');
              }
            });
            _this.setGameState(game, gameInterface);
            audio.pauseSfx();
            _context2.next = 21;
            break;
          case 20:
            throw Error("[GameView] gameId or token not set.");
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    _this.getNewGameLink = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _this$props5, navigation, setGameId, token, onGameUnavailable, gid, trigger, game;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this$props5 = _this.props, navigation = _this$props5.navigation, setGameId = _this$props5.setGameId, token = _this$props5.token, onGameUnavailable = _this$props5.onGameUnavailable;
            gid = navigation.getParam('gid', '0');
            trigger = navigation.getParam('tr', GAME_TRIGGERS.URL);
            setGameId(gid);
            if (!(gid && token.token)) {
              _context3.next = 15;
              break;
            }
            _context3.next = 7;
            return _this.fetchInitGame(gid, trigger);
          case 7:
            game = _context3.sent;
            if (game.PROVIDER) {
              _context3.next = 11;
              break;
            }
            onGameUnavailable();
            return _context3.abrupt("return");
          case 11:
            _this.setGameState(game, null);
            return _context3.abrupt("return", game);
          case 15:
            throw Error("[GameView] gameId or token not set.");
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    _this.parseBetInfo = function (betInfo) {
      if (!betInfo) return;
      if (betInfo.increments) {
        betInfo.lines = parseInt(betInfo.lines);
        betInfo.index = parseInt(betInfo.index);
        betInfo.increments = betInfo.increments.split(':');
        for (var i = 0; i < betInfo.increments.length; i++) {
          betInfo.increments[i] = parseInt(betInfo.increments[i]);
        }
      }
      if (betInfo.bonusXPThreshold && betInfo.bonusXPMultiplier) {
        betInfo.bonusXP = {
          wagerNeeded: parseFloat(betInfo.bonusXPThreshold),
          multiplier: betInfo.bonusXPMultiplier
        };
      }
      _this.props.setBetInfo(betInfo);
      return betInfo;
    };
    _this.checkFtueStep = function () {
      var ftueStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      _this.props.setOnboardingFtueStep(ftueStep);
      if (position) _this.props.setOnboardingHighlightedPosition(position, message);
    };
    _this.trackOpenedGamesAmount = function (gameId) {
      var gamesOpenedAmount = _this.props.gamesOpenedAmount + 1;
      var amountToTrack = _this.props.appsflyerGamesOpenedAmountConfig;
      if (gamesOpenedAmount == amountToTrack) {
        var balance = _this.props.balance || 0;
        var level = _this.props.level || 1;
        var tier = _this.props.tier || '';
        var eventPayload = {
          level: level,
          balance: balance,
          tier: tier,
          gameId: gameId,
          gamesOpenedAmount: gamesOpenedAmount
        };
        Logger.sendEvent(EVENT_TYPES.GAMES_OPENED_AMOUNT, eventPayload);
      }
      _this.props.setGamesOpenedAmount(gamesOpenedAmount);
    };
    _this.state = {
      gameInterface: null,
      gameLink: null,
      provider: null,
      netEntConfig: null,
      embedData: null
    };
    return _this;
  }
  _inherits(Game, _Component);
  return _createClass(Game, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$navigatio,
        _this$props$navigatio2,
        _this2 = this;
      audio.pauseMusic();
      audio.playSfx('crowdsTalking', true, 0.7);
      // RN nav v4 keeps Game in the stack across visits, so componentDidMount
      // alone misses re-entries. A `didFocus` listener guarantees the FTUE
      // state is cleared and re-armed every time the user lands on Game.
      this._didFocusSub = (_this$props$navigatio = this.props.navigation) === null || _this$props$navigatio === void 0 || (_this$props$navigatio2 = _this$props$navigatio.addListener) === null || _this$props$navigatio2 === void 0 ? void 0 : _this$props$navigatio2.call(_this$props$navigatio, 'didFocus', this.handleScreenFocus);
      // First-mount path: clear stale onboarding from the lobby, kick off init,
      // then re-arm the FTUE once the game provider is ready.
      this.props.clearOnboarding();
      this.init().then(function () {
        if (_this2.state.provider) _this2.checkOnboardingGameTutorialAction();
      });
      if (Utils.isWebOrMobileWeb() && this.props.adBlockerEnabled) {
        this.showAdBlockerPopup();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var newGameId = this.props.gameId.gameId;
      var oldGameId = prevProps.gameId.gameId;
      if (oldGameId && newGameId !== oldGameId) {
        this.init();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$_didFocusSub, _this$_didFocusSub$re, _this$state$gameInter, _this$state$gameInter2;
        var token, device;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              (_this$_didFocusSub = this._didFocusSub) === null || _this$_didFocusSub === void 0 || (_this$_didFocusSub$re = _this$_didFocusSub.remove) === null || _this$_didFocusSub$re === void 0 || _this$_didFocusSub$re.call(_this$_didFocusSub);
              (_this$state$gameInter = this.state.gameInterface) === null || _this$state$gameInter === void 0 || (_this$state$gameInter2 = _this$state$gameInter.dispose) === null || _this$state$gameInter2 === void 0 || _this$state$gameInter2.call(_this$state$gameInter);
              QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_SNEAK_PEEK_END_DATE, undefined));
              // This exists to update the players balance upon leaving the screen
              token = this.props.token.token;
              device = this.props.device;
              if (!(token && device.isConnected)) {
                _context4.next = 14;
                break;
              }
              _context4.prev = 6;
              _context4.next = 9;
              return this.props.getPlayerProfile();
            case 9:
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](6);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context4.t0),
                code: ERROR_CODE.GET_PLAYER_PROFILE_ERROR
              });
            case 14:
              this.props.clearSpinEvent();
              this.props.setGameInfo({
                gameId: '',
                gameType: '',
                gameProvider: '',
                isEmbedded: '',
                embedUrl: ''
              });
              audio.playMusic('backgroundMusic', true);
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[6, 11]]);
      }));
      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }
      return componentWillUnmount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        ftueStep = _this$props6.ftueStep,
        clearOnboarding = _this$props6.clearOnboarding,
        actionCommands = _this$props6.actionCommands;
      var _useFeatureFlags = useFeatureFlags(),
        hasFeature = _useFeatureFlags.hasFeature;
      var sneakPeekTimer = hasFeature(FE_SNEAK_PEEK) && QueryParamsProxy.findParam(RouteParamConstants.PARAM_SNEAK_PEEK_END_DATE, false);
      return this.props.render(
      // Pass state and handlers to platform renderer
      {
        gameInterface: this.state.gameInterface,
        gameProvider: this.state.provider,
        netEntConfig: this.state.netEntConfig,
        gameLink: this.state.gameLink,
        embedData: this.state.embedData,
        getNewGameLink: this.getNewGameLink,
        checkFtueStep: this.checkFtueStep,
        gameId: this.props.navigation.getParam('gid', '0'),
        ftueStep: ftueStep,
        clearOnboarding: clearOnboarding,
        sneakPeekTimer: sneakPeekTimer,
        skipTutorialGame: function skipTutorialGame() {
          return _skipTutorialGame(ftueStep, clearOnboarding, actionCommands);
        }
      });
    }
  }]);
}(Component);
export { Game as default };